import { AnimatePresence, motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { XCircle, Trash2 } from "lucide-react"; // Importa los iconos de Lucide

export default function PopoverNotifications({ setNotificationModal, notificationsModal }) {
  const navigate = useNavigate();

  const handleDeleteAllNotifications = () => {
    // Aquí puedes agregar la lógica para eliminar todas las notificaciones
    console.log("Eliminar todas las notificaciones");
  };

  return (
    <AnimatePresence>
      {notificationsModal && (
        <motion.div
          onClick={() => setNotificationModal(false)}
          className="fixed inset-0 flex items-start sm:pt-[75px] pt-[60px] sm:mr-20 mr-6 justify-end z-20"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <motion.div
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="sm:w-[350px] w-[280px] bg-background font-poppins sm:p-3 p-2 border border-gray-200 rounded-lg shadow-lg"
          >
            
            <div className="flex justify-between items-center py-2 border-b border-gray-200">
              <p className="font-semibold text-text sm:text-sm text-xs">Notificaciones</p>
              <button
                onClick={() => setNotificationModal(false)}
                className="text-gray-400 hover:text-red-600"
              >
                <XCircle className="h-5 w-5" /> 
              </button>
            </div>

            
            <div className="max-h-[300px] overflow-y-auto">
              <div className="flex items-center justify-between p-2 rounded-lg">
                <div className="flex items-center space-x-3">
                  <div className="p-2 bg-blue-100 rounded-md">
                    <span className="text-sm text-blue-600">AS</span>
                  </div>
                  <div>
                    <h1 className="font-semibold text-text sm:text-sm text-xs">Alberto Sánchez Rivas</h1>
                    <p className="text-xs text-gray-500">Nuevo prospecto: Gastronomía Mexicana</p>
                  </div>
                </div>
                <button className="text-gray-400 hover:text-red-600">
                  <Trash2 className="h-4 w-4" /> 
                </button>
              </div>
              {/* Repite este bloque para más notificaciones */}
            </div>

            {/* Pie del popover */}
            <div className="flex justify-between items-center pt-2 border-t border-gray-200">
              <button
                onClick={() => navigate("/admin/notifications")}
                className="text-blue-500 hover:text-blue-700 text-xs"
              >
                Ver todos
              </button>
              <button className="text-blue-500 hover:text-blue-700 text-xs">
                Marcar todo como leído
              </button>
              <button
                onClick={handleDeleteAllNotifications}
                className="text-red-500 hover:text-red-700 text-xs flex items-center"
              >
                <Trash2 className="h-4 w-4 mr-1" /> Eliminar todas
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}